"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Partners() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const manufacturers = [{
    name: "Automotive Systems",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/partner_auto.png"
  }, {
    name: "Metal Fabrication",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/partner_metal.png"
  }, {
    name: "Safety Solutions",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/partner_safety.png"
  }, {
    name: "Shipbuilding Tech",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/partner_ship.png"
  }, {
    name: "Precision Engineering",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/partner_precision.png"
  }, {
    name: "Industrial Logistics",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/partner_logistics.png"
  }];
  return <section data-section-id="15639" id="manufacturing-partners" className="bg-background text-foreground py-16 md:py-20 px-5 md:px-14">
      <div ref={ref} className="mx-auto max-w-[1240px]" style={{
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? "translateY(0)" : "translateY(16px)",
      transition: "opacity 600ms cubic-bezier(0.22, 1, 0.36, 1), transform 600ms cubic-bezier(0.22, 1, 0.36, 1)"
    }}>
        <div className="text-center mb-10 md:mb-14">
          <p className="font-default text-xs font-semibold uppercase text-muted-foreground" style={{
          letterSpacing: "0.14em",
          lineHeight: 1
        }}>
            Representing industry-leading manufacturers across critical sectors.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-x-6 md:gap-x-8 gap-y-6 md:gap-y-8 items-center">
          {manufacturers.map((m, i) => <div key={m.name} data-index={i} className="flex items-center justify-center h-8" style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "translateY(0)" : "translateY(16px)",
          transition: `opacity 600ms cubic-bezier(0.22, 1, 0.36, 1) ${i * 60}ms, transform 600ms cubic-bezier(0.22, 1, 0.36, 1) ${i * 60}ms`
        }}>
              <img src={m.src} data-wvc-srcset={`${m.src}-wvc-srcset`} data-wvc-sizes={`${m.src}-wvc-sizes`} alt={m.name} loading="lazy" decoding="async" className="max-h-8 w-auto object-contain opacity-60 hover:opacity-100 transition-opacity duration-[240ms] ease-out" />
            </div>)}
        </div>

        <div className="mt-16 md:mt-20 h-px w-full bg-border" />
      </div>
    </section>;
}